export default __webpack_public_path__ + "static/media/nsdl.c83ffb1b.jpg";